import exclamationSrc from '@corbado/shared-ui/assets/exclamation.svg';
import React, { memo, useRef } from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const ExclamationIcon = memo((props) => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, exclamationSrc, '--cb-error-text-color');
    return (React.createElement(Icon, { src: logoSVG, alt: 'exlamation-icon', ref: svgRef, ...props }));
});
